import { createEditor as createEditor$1 } from 'slate';
import { withReact } from 'slate-react';
import { withExtendEditor } from '../decorators/extend-editor/withExtendEditor.mjs';
import { withFragmentData } from '../decorators/fragment-data/withFragmentData.mjs';
import { withInlineVoidTypes } from '../decorators/inline-void-types/withInlineVoidTypes.mjs';
import { withRemoveEmptyNodes } from '../decorators/remove-empty-nodes/withRemoveEmptyNodes.mjs';
import { withVoidMarks } from '../decorators/void-marks/withVoidMarks.mjs';
import { pipe } from '../utilities/other/index.mjs';
import { deserializeHTML } from '../serialization/deserialize/html/deserializeHTML.mjs';

const defaultDecorators = [withExtendEditor, withFragmentData, withInlineVoidTypes, withRemoveEmptyNodes, withVoidMarks];
function createEditor({
  decorators = defaultDecorators,
  plugins,
  initialValue
}) {
  function create(plugins) {
    const baseEditor = pipe(createEditor$1(), withReact);
    baseEditor.create = create;
    return decorators.reduce((editor, decorate) => decorate(editor, plugins), baseEditor);
  }
  const editor = create(plugins);
  if (initialValue != null) {
    editor.children = typeof initialValue === 'string' ? deserializeHTML(initialValue, {
      editor,
      plugins
    }) : initialValue;
  }
  return editor;
}

export { createEditor };
